import { render, staticRenderFns } from "./ReportClarificationAlert.vue?vue&type=template&id=5e3b93f0&scoped=true&"
import script from "./ReportClarificationAlert.vue?vue&type=script&lang=js&"
export * from "./ReportClarificationAlert.vue?vue&type=script&lang=js&"
import style0 from "./ReportClarificationAlert.vue?vue&type=style&index=0&id=5e3b93f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b93f0",
  null
  
)

export default component.exports